import { Typography, Button, Anchor } from '@ui/components';
import { ArrowDown, ArrowUp } from '@ui/components/icons';
import { Trans } from 'react-i18next';
import { useState, FC } from 'react';
import { cn } from '@ui/utils';

export const TopUpPayUAgreements: FC = () => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="grid grid-cols-[1fr_auto] items-start gap-2.5">
      <div className="w-full overflow-hidden">
        <Typography
          className={cn('text-content-weak pb-1', {
            'line-clamp-2': !expanded,
          })}
          variant="labelMediumBook"
        >
          <Trans
            components={{
              payUPaymentTermsLink: <Anchor />,
              privacyPolicyLink: <Anchor />,
            }}
            i18nKey="ONBOARDING.TOP_UP.PAYU_TERMS"
          />
        </Typography>
      </div>
      <div>
        <Button
          onClick={() => setExpanded((val) => !val)}
          className="w-fit"
          variant="link"
          type="button"
          icon
        >
          {expanded ? <ArrowUp /> : <ArrowDown />}
        </Button>
      </div>
    </div>
  );
};
